import { useMemo } from 'react';
import { useGetRolesQuery } from 'api/main';
import { RoleNames, promoterRoles, roleCategories } from 'utils/constants';

export const useUserAvailableRoles = subscription => {
    const { data: roles = [], isLoading } = useGetRolesQuery();
    const isServicer = subscription?.role?.category?.name === roleCategories.SERVICERS;
    const isPromoter = subscription?.role?.category?.name === roleCategories.PROMOTERS;
    const isProvider = subscription?.role?.category?.name === roleCategories.PROVIDERS;

    const authorizedRoles = useMemo(() => {
        if (isProvider) {
            const providerRoles = [
                RoleNames.PROVIDER_ADMIN,
                RoleNames.PROVIDER_SIGNATORY,
                RoleNames.PROVIDER_STANDARD,
            ];
            return providerRoles.filter(role => role !== subscription?.role?.name);
        }

        if (isPromoter) {
            return promoterRoles.filter(role => role !== subscription?.role?.name);
        }

        return isServicer
            ? [RoleNames.SERVICER_ADMIN, RoleNames.SERVICER_STANDARD, RoleNames.SERVICER_SIGNATORY]
            : [RoleNames.COMMERCIALISATEUR, RoleNames.ADMIN_CIF]; // the only other possible category is distributors
    }, [isPromoter, isServicer, isProvider, subscription]);

    return useMemo(() => {
        if (!subscription || isLoading) return [];
        return roles.filter(r => {
            return authorizedRoles.includes(r.name);
        });
    }, [roles, subscription, authorizedRoles, isLoading]);
};
